import {
    ITagRequestAction,
    ISetSelectedReasonAction,
    setSelectedReason,
    ISetReasonStateAction,
    setReasonState,
} from "../actions/tagRequestActions";
import {IReasonState, TagRequestActions} from "../types";

const initialReasonState: IReasonState = {
    selectedReason: null,
};

export default function(state: IReasonState = initialReasonState,  action: ITagRequestAction): IReasonState {
    switch (action.type) {
        case TagRequestActions.SetSelectedReason:          return setSelectedReason(state, action as ISetSelectedReasonAction);
        case TagRequestActions.SetReasonState:             return setReasonState(state, action as ISetReasonStateAction);
        default:
            return state as IReasonState;
    }
}
